import React, { useEffect, useMemo, useState } from 'react';
import { useCollect } from 'hooks';

import Show from 'components/Show';
import Progress from 'components/Misc/Progress';
import Nothing from 'components/Misc/Nothing';
import Container from 'components/Misc/Container';

import Search from 'containers/Shared/Exams/Profile/Students/Search';
import Student from 'containers/Shared/Exams/Profile/Students/Student';
import Edit from 'containers/Shared/Exams/Profile/Students/Edit';

import { useExamProfileStore } from 'store/exam/useExamProfileStore';

const Students = ({ tab, setTab }) => {
	// Update selected tab on mount
	useEffect(() => setTab(tab), []);

	// Use exam's profile store
	const uuid = useExamProfileStore(state => state.exam.uuid);

	// Store edit take
	const [edit, setEdit] = useState(0);

	// Store search bar's data
	const [search, setSearch] = useState({
		name: '',
		state: ''
	});

	// Store request parameters
	const parameters = useMemo(() => ({
		eager: 'student',
		'exam.uuid': uuid, 
		'state:in': search.state || 'assigned,active',
		'student.name|student.surname:likeLower': `%${search.name}%`,
	}), [uuid, search]);

	// Store requested takes
	const [[takes, progress], collect] = useCollect('takes', parameters);

	// Handle search input change
	const onSearch = ({ name, value }) => {
		setSearch(prev => ({
			...prev,
			[name]: value
		}));
	};

	// Collect exam on mount and on parameter change
	useEffect(() => {
		(async () => await collect())();
	}, [collect]);

	// TODO: Remove after test
	useEffect(() => console.log('EXAMS.STUDENTS:', takes), [takes]);

	return (
		<>
			{/* Search container */}
			<Search search={search} onChange={onSearch} />
					
			{/* Show loading progress */}
			<Progress progress={progress} />

			{/* Show nothing found */}
			<Nothing visible={!takes?.length && !progress} />

			{/* Show collection if results collected */}
			<Show if={takes?.length && !progress}>
				<Container className="mt-4 flex flex-col transition-all">
					{takes?.map(take =>
						<Student key={take.id} take={take} handleEdit={setEdit} />
					)}
				</Container>
			</Show>

			{/* Student's edit modal */}
			<Edit id={edit} handleEdit={setEdit} takes={takes} />
		</>
	);
};

export default Students;